<section class="ref-view">
    <div class="ref-panel">
        <div class="ref-panel-h">
            <div>
                <h2>Programs and rewards</h2>
                <p>These amounts show on the refer and earn page and decide partner rewards for new referrals.</p>
            </div>
            <button class="btn btn-primary" type="button" (click)="save()"><i class="fas fa-save mr-50"></i>Save changes</button>
        </div>
        <div class="ref-tbl-wrap">
            <table>
                <thead>
                <tr><th>Program</th><th>University</th><th>Partner reward (₹)</th><th>Student discount (₹)</th><th>Show on site</th></tr>
                </thead>
                <tbody>
                <tr *ngIf="loading">
                    <td colspan="5" class="ref-empty">Loading…</td>
                </tr>
                <tr *ngIf="!loading && !rows.length">
                    <td colspan="5" class="ref-empty">No programs found. Link a popular course to a university first.</td>
                </tr>
                <tr *ngFor="let r of rows">
                    <td><b>{{r.p.name}}</b></td>
                    <td>{{r.p.uni}}</td>
                    <td>
                        <input class="ref-inp ref-cell" type="number" min="0" step="500" [(ngModel)]="r.reward"
                               [class.ref-bad]="submitted && invalid(r.reward)" [attr.aria-label]="'Partner reward for ' + r.p.name">
                    </td>
                    <td>
                        <input class="ref-inp ref-cell" type="number" min="0" step="500" [(ngModel)]="r.discount"
                               [class.ref-bad]="submitted && invalid(r.discount)" [attr.aria-label]="'Student discount for ' + r.p.name">
                    </td>
                    <td>
                        <label class="ref-switch">
                            <input type="checkbox" [(ngModel)]="r.active" [attr.aria-label]="'Show ' + r.p.name + ' on site'"><span></span>
                        </label>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>
